import { CustomCellRendererProps } from "ag-grid-react";
import { defineColumn, transferRowDataInternal } from "presentation/view/components/TableWrapper/BasicTableConstants";
import { ProposalCopyingForRecalConstant } from "./ProposalCopyingForRecalConstant";

const PROPOSAL_COPY_FOR_RECAL_CONSTANT = ProposalCopyingForRecalConstant.Table;
let dateFieldList: string[] = [];
let dateTimeFieldList: string[] = [];
export const INITIAL_PROPOSAL_COPY_FOR_RECAL_COL_DEF: any[] = [
    {
        headerName: PROPOSAL_COPY_FOR_RECAL_CONSTANT.COMPANY_CODE,
        field: 'companyCode',
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        // pinned: "left",
        checkboxSelection: true,
        headerCheckboxSelection: true,
        filter: true,
        width: 200,
    },
    {
        headerName: PROPOSAL_COPY_FOR_RECAL_CONSTANT.PROPOSAL_NO,
        field: 'proposalNo',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 150,
    },
    {
        headerName: PROPOSAL_COPY_FOR_RECAL_CONSTANT.EFFECTIVE_DATE,
        field: 'effectiveDate',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 150,
        dataType: "date"
    },
    {
        headerName: PROPOSAL_COPY_FOR_RECAL_CONSTANT.EXPIRY_DATE,
        field: 'expiryDate',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 150,
        dataType: "date"
    },
    {
        headerName: PROPOSAL_COPY_FOR_RECAL_CONSTANT.OPERATING_TML,
        field: 'operatingTml',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 160,
    },
    {
        headerName: PROPOSAL_COPY_FOR_RECAL_CONSTANT.CURRENCY,
        field: 'currencyCode',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 120,
    },
    {
        headerName: PROPOSAL_COPY_FOR_RECAL_CONSTANT.PROPOSAL_BY,
        field: 'proposalBy',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 150,
    },
    {
        headerName: PROPOSAL_COPY_FOR_RECAL_CONSTANT.TARIFF_NATURE,
        field: 'tariffNature',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 180,
    },
    // {
    //     headerName: PROPOSAL_COPY_FOR_RECAL_CONSTANT.CONFIRMED_DATE,
    //     field: 'confirmedDate',
    //     enableRowGroup: true,
    //     enablePivot: true,
    //     enableValue: true,
    //     filter: true,
    //     width: 180,
    //     dataType: "date"
    // },
    // {
    //     headerName: PROPOSAL_COPY_FOR_RECAL_CONSTANT.STATUS,
    //     field: 'status',
    //     enableRowGroup: true,
    //     enablePivot: true,
    //     enableValue: true,
    //     filter: true,
    //     width: 120,
    // },
    {
        headerName: PROPOSAL_COPY_FOR_RECAL_CONSTANT.REMARKS,
        field: 'remarks',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 150,
    },
    // {
    //     headerName: PROPOSAL_COPY_FOR_RECAL_CONSTANT.REJECT_REASON,
    //     field: 'rejectReason',
    //     enableRowGroup: true,
    //     enablePivot: true,
    //     enableValue: true,
    //     filter: true,
    //     width: 380,
    // },


].map((col, index) => {
    const cellRenderers: { [key: string]: ((params: CustomCellRendererProps) => {}) } = {};

    return defineColumn(col, index, dateFieldList, dateTimeFieldList, [], cellRenderers);
});

export const transferRowData = (data: any[]) => {
    const externalFnctions: { [key: string]: ((fieldName: string, row: any) => {}) } = {};

    return transferRowDataInternal(data, dateFieldList, dateTimeFieldList, [], externalFnctions);
}
